export var ContentstackLocalesEnum;
(function (ContentstackLocalesEnum) {
    ContentstackLocalesEnum["tr-tr"] = "tr-tr";
    ContentstackLocalesEnum["hu-hu"] = "hu-hu";
    ContentstackLocalesEnum["no-no"] = "no-no";
    ContentstackLocalesEnum["pt-br"] = "pt-br";
    ContentstackLocalesEnum["hr-hr"] = "hr-hr";
    ContentstackLocalesEnum["cs-cz"] = "cs-cz";
    ContentstackLocalesEnum["nl-nl"] = "nl-nl";
    ContentstackLocalesEnum["fi-fi"] = "fi-fi";
    ContentstackLocalesEnum["fr-fr"] = "fr-fr";
    ContentstackLocalesEnum["it-it"] = "it-it";
    ContentstackLocalesEnum["pl-pl"] = "pl-pl";
    ContentstackLocalesEnum["sl-si"] = "sl-si";
    ContentstackLocalesEnum["es-es"] = "es-es";
    ContentstackLocalesEnum["sv-se"] = "sv-se";
    ContentstackLocalesEnum["ja-jp"] = "ja-jp";
    ContentstackLocalesEnum["zh-cn"] = "zh-cn";
    ContentstackLocalesEnum["de-de"] = "de-de";
    ContentstackLocalesEnum["da-dk"] = "da-dk";
    ContentstackLocalesEnum["en"] = "en";
    ContentstackLocalesEnum["en-us"] = "en-us";
})(ContentstackLocalesEnum || (ContentstackLocalesEnum = {}));
